export default {

  // 접속한 계정에 노출되는 메뉴 리스트
  list:[],
  // 메뉴 검색
  search: '',

  pageTitle: '',
  pagePath:[],

  // 메인화면에서 노출되는 팝업 리스트
  modalItems: [],

  // 사용가능한 boardIds, 대시보드 표기 여부를 판단하기 위해 사용하고 있음.
  availableBoardIds: [],
}
